import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResponse } from '../../../shared/commons/page-response';

export interface CertificateAuthorityDto {
  id?: number;
  issuerCn?: string;
  issuerOu?: string;
  issuerO?: string;
  issuerL?: string;
  issuerC?: string;
  subjectCn?: string;
  subjectOu?: string;
  subjectO?: string;
  subjectL?: string;
  subjectC?: string;
  validFrom?: string;
  validTo?: string;
  revocationUrl?: string;
  certificateFile?: string;
  certificateFileName?: string;
  ordering?: number;
  state?: number;
  checkedOut?: number;
  checkedOutTime?: string;
  createdAt?: string;
  modifiedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class CertificateAuthorityService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/certificate-authorities';

  getAllCertificateAuthorities(page: number, size: number, search: string = '', state: number | null = null): Observable<PageResponse<CertificateAuthorityDto>> {
    return this.http.get<PageResponse<CertificateAuthorityDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state));
  }

  getActiveCertificateAuthorities(): Observable<CertificateAuthorityDto[]> {
    return this.http.get<CertificateAuthorityDto[]>(`${this.apiUrl}/active`);
  }

  getCertificateAuthorityById(id: number): Observable<CertificateAuthorityDto> {
    return this.http.get<CertificateAuthorityDto>(`${this.apiUrl}/${id}`);
  }

  downloadCertificateAuthorityFile(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/download`, { responseType: 'blob' });
  }

  createCertificateAuthority(dto: CertificateAuthorityDto): Observable<CertificateAuthorityDto> {
    return this.http.post<CertificateAuthorityDto>(this.apiUrl, dto);
  }

  previewCertificateAuthority(file: File): Observable<CertificateAuthorityDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<CertificateAuthorityDto>(`${this.apiUrl}/preview`, formData);
  }

  uploadCertificateAuthority(file: File): Observable<CertificateAuthorityDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<CertificateAuthorityDto>(`${this.apiUrl}/upload`, formData);
  }

  updateCertificateAuthority(id: number, dto: CertificateAuthorityDto): Observable<CertificateAuthorityDto> {
    return this.http.put<CertificateAuthorityDto>(`${this.apiUrl}/${id}`, dto);
  }

  deleteCertificateAuthority(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
